import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { isPossiblePhoneNumber } from "libphonenumber-js";

import { Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import OtpInput from "../OtpInput";

import useApi from "../../hooks/useApi";

import "./style.scss";

const CountryCode = ({
  phone,
  changePhone,
  onFormData,
  label,
  name,
  disability,
  onFocus,
  onBlur,
  autoFocus = false,
  hasError = false,
  showStatusIcon = false,
  needsVerification = false,
  setMobileNeedsVerification,
  errorMsg = "",
  size = "small",
}) => {
  const { t } = useTranslation();
  const { post } = useApi();
  const [focused, setFocused] = useState(false);

  const [verifiedPhone, setVerifiedPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [otpHasError, setOtpHasError] = useState(false);

  let inputStyle = {
    width: "100%",
    height: size === "small" ? "40px" : "56px",
    background: "none",
    border: focused ? "2px solid" : "1px solid",
    borderColor: focused
      ? "#1976d2"
      : hasError
        ? "#d32f2f"
        : "rgba(0, 0, 0, 0.23)",
    borderRadius: "4px",
    fontSize: "16px",
  };

  let buttonStyle = {
    border: focused ? "2px solid" : "1px solid",
    borderColor: focused
      ? "#1976d2"
      : hasError
        ? "#d32f2f"
        : "rgb(220 220 220)",
    background: "none",
  };

  useEffect(() => {
    const flagButton = document.querySelector(".selected-flag");
    flagButton.setAttribute("tabindex", "-1");
  }, []);

  const handleChange = (value) => {
    setShowOtpInput(false);
    setOtp("");
    setOtpHasError(false);

    if (changePhone) changePhone(value);
  };

  const handleFocus = (e) => {
    setFocused(true);

    if (onFocus) {
      onFocus(e);
    }
  };

  const handleBlur = (e) => {
    setFocused(false);

    if (onBlur) {
      onBlur(e);
    }
  };

  const sendOTP = async () => {
    setShowOtpInput(true);

    try {
      await post("/Otp/create", {
        phoneNumber: phone,
      });
    } catch (err) {
      console.error("otp send filed:", err);
    }
  };

  const validateOtp = async () => {
    try {
      const resp = await post("/Otp/validate", {
        phoneNumber: phone,
        code: otp,
      });

      if (resp.isValid) {
        setVerifiedPhone(phone);
        setShowOtpInput(false);

        if (setMobileNeedsVerification) setMobileNeedsVerification(false);
      } else {
        setOtpHasError(true);
      }
    } catch (err) {
      console.error("otp validation filed:", err);
    }
  };

  return (
    <div className="phone-input-wrapper">
      <label
        htmlFor="phone"
        className={`phone-input-label ${focused ? "focused" : ""} ${hasError ? "error" : ""}`}
      >
        {label || t("input_label_phone")}
      </label>

      {showStatusIcon && isPossiblePhoneNumber(`+${phone}`) && (
        <div className="verify-btn">
          {verifiedPhone === phone || !needsVerification ? (
            <CheckCircleIcon color="success" />
          ) : (
            <Button
              variant="text"
              sx={{
                minWidth: "36px",
                padding: 0,
                textTransform: "none",
              }}
              onClick={sendOTP}
              disabled={showOtpInput}
            >
              {t("verify")}
            </Button>
          )}
        </div>
      )}

      <PhoneInput
        country={"us"}
        value={phone}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        enableSearch
        disabled={disability ? disability : false}
        inputProps={{
          name: name || "phone",
          id: "phone",
          autoComplete: "tel",
          autoFocus,

          onKeyDown: (e) => {
            if (e.key === "Enter") e.target.form?.requestSubmit();
          },
        }}
        inputStyle={{
          ...inputStyle,
        }}
        buttonStyle={{
          ...buttonStyle,
        }}
        containerStyle={{
          marginTop: "16px",
          marginBottom: "8px",
        }}
      />
      {hasError && (
        <p className="phone-input-error">
          {errorMsg ||
            t(!!phone ? "error_incorrect_phone" : "error_input_required")}
        </p>
      )}
      {showOtpInput && needsVerification && (
        <OtpInput
          otp={otp}
          otpHasError={otpHasError}
          setOtp={setOtp}
          setOtpHasError={setOtpHasError}
          validateOtp={validateOtp}
        />
      )}
    </div>
  );
};

export default CountryCode;
